// Shared by the game, ZIP importer, editor and template builder.
export const VOICE_CHARACTERS = Object.freeze([
    ['billyjoel', 'Billy Joel'], ['jeroen', 'Jeroen'], ['marique', 'Marique'],
    ['damien', 'Damien'], ['thezuck', 'The Zuck!'], ['bobzombie', 'Bob Zombie'],
    ['xenot', 'Xenot'], ['ronda', 'Ronda'], ['jacklee', 'Jack Lee'],
    ['coljackson', 'Col. Jackson'], ['hank', 'Hank'], ['mrskat', 'Mrs. Kat'],
    ['seanbro', 'Sean Bro'], ['crashy', 'Crashy'], ['brittany', 'Brittany'], ['machote', 'Machote'],
].map(([slug, name], skin) => Object.freeze({slug, name, skin})));

export const VOICE_SLOTS = Object.freeze({
    select_01: 'Character selected', damage_01: 'Damage grunt 1',
    damage_02: 'Damage grunt 2', damage_03: 'Damage grunt 3',
    damage_word_01: 'Damage exclamation', hat_01: 'Hat pickup',
    eject_01: 'Leave vehicle', win_01: 'Victory', death_01: 'Death',
});
export const VOICE_MAX_BYTES = 5 * 1024 * 1024;
export const BUILTIN_VOICE_SLUGS = Object.freeze(VOICE_CHARACTERS.map(({slug}) => slug));
// File folders follow the original picker order, unlike the stable skin IDs.
export const CHARACTER_TEXTURE_FOLDERS = Object.freeze([0, 1, 2, 3, 12, 9, 14, 6, 7, 8, 4, 10, 13, 5, 11, 15]
    .map(skin => VOICE_CHARACTERS[skin].slug));

export function characterDisplayName(skin, theme) {
    try {
        if (typeof theme === 'string') theme = JSON.parse(theme);
        const name = theme?.charNames?.[skin];
        if (typeof name === 'string' && name.trim()) return name.trim();
    } catch { /* Incomplete theme edits retain the original labels. */ }
    return VOICE_CHARACTERS[skin]?.name || 'Character';
}
export const MOD_ATLASES = Object.freeze({
    Mech: 'vehicles/Mech', Weapons: 'prefabs/Weapons', Movement: 'prefabs/Movement',
    Construction: 'prefabs/Construction', Nature: 'prefabs/Nature', Misc: 'prefabs/Misc',
    Level: 'prefabs/Level', particles: 'particles/particles',
});

export function normalizeModPath(path) {
    if (typeof path !== 'string' || path.includes('\\')) return null;
    const parts = path.split('/');
    if (parts.some(part => part === '..' || part === '.') || parts[0] === '__MACOSX') return null;
    const folders = ['characters', 'kids', 'babies', 'gore', 'masks', 'textures', 'vehicles',
        'portraits', 'helmets', 'hats', 'ropes', 'theme', 'audio', 'atlases'];
    if (!folders.includes(parts[0])) parts.shift();
    return folders.includes(parts[0]) ? `jollymod/${parts.join('/')}` : null;
}

export function parseVoicePath(path) {
    const match = /^jollymod\/audio\/voices\/([a-z]+)\/([a-z_]+\d+)\.(mp3|wav)$/i.exec(path);
    if (!match) return null;
    const [, slug, slot, extension] = match.map(value => value.toLowerCase());
    const character = VOICE_CHARACTERS.find(item => item.slug === slug);
    if (!character || !Object.hasOwn(VOICE_SLOTS, slot)) return null;
    return {slug, slot, skin: character.skin, extension, sprite: `${slug}_${slot}`,
        path: `jollymod/audio/voices/${slug}/${slot}.${extension}`};
}
